import { Dialog, DialogTitle } from "@mui/material";
import { useStore } from "../../store/store"; 

type onCloseReason = "backdropClick" | "escapeKeyDown"

export const AppDialog = () => {
    const {appDialog} = useStore()

    const handleClose = (e: any, reason: onCloseReason) => {
        if (reason === "backdropClick" && !appDialog.allowSoftCancel) return;
        appDialog.toggleIsOpen();
        appDialog.onCancel?.();
  };

    return (
        <Dialog 
            open={appDialog.isOpen}  
            onClose={handleClose}
            aria-labelledby={appDialog.title} 
            maxWidth={appDialog.maxWidth} 
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 4,
                },
            }}
            sx={{
                '& .MuiDialog-container': {
                    '& .MuiPaper-root': {
                        overflow: 'visible',
                    },
                },
            }}
        >
            {appDialog.title && <DialogTitle id={appDialog.title}>{appDialog.title}</DialogTitle>}
            {appDialog.contentAndActions}
        </Dialog>
    );
};
